const vacancyResponseForm = document.querySelector('.respond-to-vacancy');
const topBar = document.querySelector('[data-top-bar]');

export default function initVacancyResponse() {
    if (vacancyResponseForm) {
        // Scroll to form when form has errors
        const vacancyResponseFormErrors = vacancyResponseForm.querySelectorAll('.text-danger').length;
        const vacancyResponseSuccesMessage = vacancyResponseForm.querySelectorAll('[data-success]').length;

        if (vacancyResponseFormErrors > 0 || vacancyResponseSuccesMessage > 0) {
            let scrollOffsetTop = -(topBar.offsetHeight + 180);
            if (window.innerWidth <= 768) {
                scrollOffsetTop = 0;
            }

            vacancyResponseForm.scrollIntoView();
            window.scrollBy(0, scrollOffsetTop);
        }
    }
}
